// Truncates on raw character count.
export function truncateChars(text, limit = 30) {
  if (!text) return text;
  return text.length > limit ? `${text.slice(0, limit).trimEnd()}...` : text;
}

// Truncates on letter count only (digits/spaces/punctuation don't count
// toward the limit), so e.g. "Season 12: The Return" truncates based on how
// many actual letters it has, not its raw length.
export function truncateByLetters(str, maxLetters) {
  if (!str) return str;
  let letterCount = 0;
  let cutIndex = str.length;
  for (let i = 0; i < str.length; i++) {
    if (/[a-zA-Z]/.test(str[i])) letterCount++;
    if (letterCount > maxLetters) {
      cutIndex = i;
      break;
    }
  }
  return letterCount > maxLetters ? `${str.slice(0, cutIndex)}...` : str;
}
